export default (ifEdit) => ({
  enterpriseName: [
    {
      required: true,
      message: '请选择企业',
      trigger: 'blur',
    },
  ],
  userName: [
    {
      required: true,
      message: '请填写账号名',
      trigger: 'blur',
    },
  ],

  userPwd: [
    {
      required: !ifEdit,
      message: '请填写密码',
      trigger: 'blur',
    },
  ],

  phone: [
    {
      required: true,
      message: '请填写手机号码',
      trigger: 'blur',
    },
    {
      pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
      message: '手机号格式错误',
    },
  ],
  email: [
    {
      pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
      message: '邮箱格式错误',
    },
  ],
})



// WEBPACK FOOTER //
// ./src/pages/index/views/accManage/rules.js